import styled, { css, keyframes } from 'styled-components'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import { Button, theme } from '@notino/react-styleguide'
import { NotinoLabelSmall400, NotinoTitleMedium, resetButtonStyles } from '../../styles/helpers'
import { BREAKPOINTS, BREAKPOINTS_INTS } from '../../styles/constants'
import RenderPrice from '../RenderPrice/RenderPrice'
import { RESERVATION_BOOKING_MODAL_LEFT_COL_WIDTH_DESKTOP, RESERVATION_BOOKING_MODAL_MAX_WIDTH_DESKTOP } from '../../utils/enums'

// we need to add 1px while overriding styles because Notino components use max-width instead of min-widths
const MODAL_BREAKPOINT = `${BREAKPOINTS_INTS.sm + 1}px`

const detailAppearAnimation = keyframes`
	from {
		transform: translateY(100%);
		opacity: 0;
	}
	to {
		transform: translateY(0);
		opacity: 1;
	}
`
export const DotDivider = styled.div`
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background-color: #9f9f9f;
`

export const ReservationModalScreenWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;

	@media (min-width: ${BREAKPOINTS.lg}) {
		width: ${RESERVATION_BOOKING_MODAL_MAX_WIDTH_DESKTOP}px;
		padding-left: ${RESERVATION_BOOKING_MODAL_LEFT_COL_WIDTH_DESKTOP}px;
	}
`

export const ReservationModalScreen = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	background: white;
	z-index: 2;
	transform: translateY(100%);
	opacity: 0;
	animation: ${detailAppearAnimation} 0.3s forwards;
	overflow: hidden;
`

export const ScrollContainer = styled(OverlayScrollbarsComponent)<{ $isReservationBookingModal: boolean }>`
	overflow-y: auto;
	height: 100%;

	${({ $isReservationBookingModal }) =>
		!$isReservationBookingModal &&
		css`
			@media (min-width: ${MODAL_BREAKPOINT}) {
				height: auto;
			}
		`}
`

export const CloseButton = styled.button`
	${resetButtonStyles};
	position: absolute;
	right: 20px;
	top: 20px;
	z-index: 2;
`

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 20px;
	max-width: 920px;

	@media (min-width: ${MODAL_BREAKPOINT}) {
		padding: 24px;
	}
`

export const ServiceCategoryTitle = styled.div`
	${NotinoTitleMedium};
	margin-bottom: 4px;
	margin-right: 30px;
`

export const PriceAndDurationContainer = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-bottom: 16px;
	gap: 8px;
`

export const OccupancyContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	svg {
		flex-shrink: 0;
	}
`

export const OccupancyLabel = styled.div`
	${NotinoLabelSmall400};
`

export const ServicePrice = styled(RenderPrice)`
	${NotinoLabelSmall400};
`

export const ServiceDuration = styled.div`
	display: flex;
	align-items: center;
	${NotinoLabelSmall400};
`

export const DurationIcon = styled.div`
	margin-right: 5px;
	flex-shrink: 0;

	& > svg {
		width: 12px;
		height: 12px;
	}
`

export const DurationText = styled.div`
	${NotinoLabelSmall400};
	white-space: nowrap;
`

export const BookOnlineButton = styled(Button)`
	margin-left: auto;
`

export const ServiceDescription = styled.div`
	color: ${theme.color.text.secondary};
	${NotinoLabelSmall400};
	white-space: pre-wrap;
	margin-bottom: 20px;
`
export const ButtonsWrapper = styled.div`
	margin-top: auto;
	position: sticky;
	bottom: 0;
	margin: auto -20px -20px -20px;
	padding: 20px;
	background: ${theme.color.background.primary};

	@media (min-width: ${MODAL_BREAKPOINT}) {
		margin: auto -24px -24px -24px;
		padding: 24px;
	}
`
